<template>
  <transition name="right">
    <div
      class="container" v-if="isOpened"
    >
      <!-- 詳細シート設定 -->
      <h2 style="margin-bottom: 8px; font-weight: 600">
        <span class="mdi mdi-table-settings" style="margin-right: 8px"></span>詳細シート設定
      </h2>
      <!-- パンくずリスト -->
      <div style="margin-top: 16px; margin-bottom: 8px; font-weight: 600; text-align: left;">
        <a style="margin-right: 4px;" @click="selectTemplate(undefined)">
          <span class="mdi mdi-chevron-right-box-outline" style="margin-right: 4px;"></span>詳細シート
        </a>
        <a style="margin-right: 4px;" v-if="selectedTemplate">
          / <span class="mdi mdi-bookmark" style="margin-right: 4px;"></span>{{selectedTemplate.name}}
        </a>
      </div>
      
      <span v-if="selectedTemplate == undefined">
        <div style="display: flex; align-items: center; margin-bottom: 8px;">
          <input
            class="input is-small"
            placeholder="新規シート名"
            v-model="newTemplateName"
            style="width: calc(100% - 60px);"
          />
          <button class="button is-small" style="width: 60px" @click="createTemplate()">
            <span class="mdi mdi-plus" style="margin-right: 8px"></span>追加
          </button>
        </div>
        <span class="mdi mdi-spin mdi-loading mdi-48px" v-if="isLoading"></span>
        <table class="disp-scroll" v-if="!isLoading">
          <tr style="display: table;">
            <th style="width: 60px;">移動</th>
            <th style="width: 60px;">順番</th>
            <th style="width: 250px;">
              シート名
              <span class="mdi mdi-square-edit-outline"
                style="padding-left: 8px;cursor: pointer;"
                @click="isEditingTemplateName=true"
                v-if="!isEditingTemplateName"></span>
              <span class="mdi mdi-content-save"
                style="padding-left: 8px;cursor: pointer;"
                @click="saveTemplates();isEditingTemplateName=false"
                v-if="isEditingTemplateName"></span>
              <span class="mdi mdi-cancel"
                style="padding-left: 8px;cursor: pointer;"
                @click="loadTemplates();isEditingTemplateName=false"
                v-if="isEditingTemplateName"></span>
            </th>
            <th style="width: 60px;">削除</th>
          </tr>
          <draggable id="story-list" :list="sheetTemplates" @end="updateTemplateOrder()" :options="{animation: 300, group: { name: 'TEMP', pull: 'clone', put: false}, handle: '.drag-button'}">
            <tr style="display: table;" v-for="(template, i) in sheetTemplates" :key="i + '-col'">
              <td style="width: 60px; vertical-align: middle; padding: 0; overflow: hidden;">
                <button class="drag-button trans-btn"><span class="mdi mdi-drag mdi-24px"></span></button>
              </td>
              <td style="width: 60px; vertical-align: middle;">{{template.order + 1}}</td>
              <td style="width: 250px; max-width: 250px; min-width: 250px; text-align: left; vertical-align: middle;">
                <input class="input is-small" style="background: transparent;" v-model="template.name" v-if="isEditingTemplateName"/>
                <div class="omit-text" style="height: 35px; line-height: 35px; padding-left: 5px; text-decoration:underline; cursor: pointer;"
                  @click="selectTemplate(template)" v-if="!isEditingTemplateName">{{template.name}}</div>
              </td>
              <td style="width: 60px; text-align: center; vertical-align: middle;">
                <template>
                  <div style="display: flex;">
                    <button class="trans-btn" @click="deleteTemplate(template)">
                      <span class="mdi mdi-close"></span>
                    </button>
                  </div>
                </template>
              </td>
            </tr>
          </draggable>
        </table>
      </span>
      <span v-if="selectedTemplate != undefined">
        <div style="display: flex; align-items: center; margin-bottom: 8px">
          <input
            class="input is-small"
            placeholder="新規項目名"
            v-model="newColumnName"
            style="width: calc(100% - 60px)"
          />
          <select class="select is-small disp-scroll" style="width: 120px" v-model="manageColumnPk">
            <option :value="c_op.pk" v-for="c_op in manageColumnOptions()" :key="c_op.pk">
              {{ c_op.name }}
            </option>
          </select>
          <button class="button is-small" style="width: 60px" @click="createColumn()">
            <span class="mdi mdi-plus" style="margin-right: 8px"></span>追加
          </button>
        </div>
        <span class="mdi mdi-spin mdi-loading mdi-48px" v-if="isLoading"></span>
        <table class="disp-scroll" v-if="!isLoading">
          <tr style="display: table;">
            <th style="width: 60px;">移動</th>
            <th style="width: 60px;">順番</th>
            <th style="width: 190px;">
              項目名
              <span class="mdi mdi-square-edit-outline"
                style="padding-left: 8px;cursor: pointer;"
                @click="isEditingColumnName=true"
                v-if="!isEditingColumnName"></span>
              <span class="mdi mdi-content-save"
                style="padding-left: 8px;cursor: pointer;"
                @click="saveColumns();isEditingColumnName=false"
                v-if="isEditingColumnName"></span>
              <span class="mdi mdi-cancel"
                style="padding-left: 8px;cursor: pointer;"
                @click="loadColumns();isEditingColumnName=false"
                v-if="isEditingColumnName"></span>
            </th>
            <th style="width: 100px;">引用設定</th>
            <th style="width: 60px;">削除</th>
          </tr>
          <draggable id="story-list" :list="sheetColumns" @end="updateColumnOrder()" :options="{animation: 300, group: { name: 'TEMP', pull: 'clone', put: false}, handle: '.drag-button'}">
            <tr style="display: table;" v-for="(column, i) in sheetColumns" :key="i + '-col'">
              <td style="width: 60px; vertical-align: middle; padding: 0; overflow: hidden;">
                <button class="drag-button trans-btn"><span class="mdi mdi-drag mdi-24px"></span></button>
              </td>
              <td style="width: 60px; vertical-align: middle;">{{i + 1}}</td>
              <td style="width: 190px; max-width: 190px; min-width: 190px; text-align: left; vertical-align: middle;">
                <input class="input is-small" style="background: transparent;" v-model="column.name" v-if="isEditingColumnName"/>
                <div class="omit-text" style="height: 35px; line-height: 35px; padding-left: 5px;" v-if="!isEditingColumnName">{{column.name}}</div>
              </td>
              <td style="width: 100px; max-width: 100px; min-width: 100px; text-align: left; vertical-align: middle;">
                <div class="omit-text" style="height: 35px; line-height: 35px; padding-left: 5px;">{{getManageColumnName(column.refer_column)}}</div>
              </td>
              <td style="width: 60px; text-align: center; vertical-align: middle;">
                <template>
                  <div style="display: flex;">
                    <button class="trans-btn" @click="deleteColumn(column)">
                      <span class="mdi mdi-close"></span>
                    </button>
                  </div>
                </template>
              </td>
            </tr>
          </draggable>
        </table>
      </span>
    </div>
  </transition>
</template>

<script>
import { mapState }    from 'vuex'
import draggable from 'vuedraggable'
export default {
  props: {
    isOpened: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    draggable,
  },
  data() {
    return {
      sheetTemplates: [],
      newTemplateName: '',
      isEditingTemplateName: false,
      sheetColumns: [],
      newColumnName: '',
      isEditingColumnName: false,
      manageColumnPk: null,
      selectedTemplate: undefined,
      isLoading: false,
      detailSheetItem: []
    }
  },
  computed: {
    ...mapState('auth', ['companyColumnSetting']),
  },
  watch: {
    isOpened () {
      if (this.isOpened) {
        this.selectedTemplate = undefined
        this.manageColumnPk = null
        this.newTemplateName = ''
        this.newColumnName = ''
        // 開いたときに読み込み
        this.loadTemplates()
      }
    },
    selectedTemplate () {
      if (this.selectedTemplate != undefined) {
        this.newColumnName = ''
        this.sheetColumns = []
        this.loadColumns()
      }
      else {
        this.newTemplateName = ''
        this.sheetTemplates = []
        this.loadTemplates()
      }
    },
    companyColumnSetting () {
      this.detailSheetItem = this.companyColumnSetting.filter(
        column => column.name !== 'ロボ会話履歴' &&
        column.name !== 'ファイル' &&
        column.name !== 'スカウト' &&
        column.name !== '連携ID' &&
        column.name !== '外部情報' &&
        column.name !== '録画面接' &&
        column.name !== 'フラグ'
      )
    }
  },
  methods: {
    loadTemplates () {
      this.isLoading = true
      this.$store.dispatch('auth/getDetailSheetTemplateList')
      .then((d) => {
        this.sheetTemplates = d.data
        this.isLoading = false
      })
    },
    saveTemplates () {
      this.$store.dispatch('auth/setDetailSheetTemplateList', this.sheetTemplates)
      .then((d) => {
        this.sheetTemplates = d.data
      })
    },
    createTemplate () {
      if (this.newTemplateName == '') return
      this.sheetTemplates.push({
        name: this.newTemplateName,
        order: this.sheetTemplates.length
      })
      this.newTemplateName = ''
      this.saveTemplates()
    },
    deleteTemplate (template) {
      if (confirm('このシートに紐づいた項目設定・入力データも合わせて削除されます。\nよろしいですか？')) {
        this.sheetTemplates = this.sheetTemplates.filter((t) => t != template)
        this.updateTemplateOrder()
      }
    },
    updateTemplateOrder () {
      for (let i=0; i < this.sheetTemplates.length; i++) {
        this.sheetTemplates[i].order = i
      }
      this.saveTemplates()
    },
    selectTemplate (template) {
      if (template == undefined) {
        // 選択解除
        this.selectedTemplate = undefined
      }
      else {
        // 選択
        if (template.hasOwnProperty('id')) {
          this.selectedTemplate = template
        }
      }
    },
    manageColumnOptions () {
      return [{pk: null, name: '未設定 (自由入力)'}].concat(this.detailSheetItem)
    },
    loadColumns () {
      this.isLoading = true
      this.$store.dispatch('auth/getDetailSheetColumnList', this.selectedTemplate.id)
      .then((d) => {
        this.sheetColumns = d.data
        this.isLoading = false
      })
    },
    saveColumns () {
      if (this.selectedTemplate == undefined) return
      this.$store.dispatch('auth/setDetailSheetColumnList', {
        template_id: this.selectedTemplate.id,
        data: this.sheetColumns
      })
      .then((d) => {
        this.sheetColumns = d.data
      })
    },
    createColumn () {
      if (this.newColumnName == '') return
      this.sheetColumns.push({
        name: this.newColumnName,
        order: this.sheetColumns.length,
        refer_column: this.manageColumnPk
      })
      this.newColumnName = ''
      this.manageColumnPk = null
      this.saveColumns()
    },
    deleteColumn (column) {
      if (confirm('この項目に紐づいた入力データも合わせて削除されます。\nよろしいですか？')) {
        this.sheetColumns = this.sheetColumns.filter((c) => c != column)
        this.updateColumnOrder()
      }
    },
    updateColumnOrder () {
      for (let i=0; i < this.sheetColumns.length; i++) {
        this.sheetColumns[i].order = i
      }
      this.saveColumns()
    },
    getManageColumnName (pk) {
      let column = this.companyColumnSetting.find((op) => op.pk == pk)
      if (column) return column.name
      else return '不明な項目'
    }
  }
}
</script>

<style lang="scss" scoped>
table td:not([align]),
table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
  display: block;
  //overflow: scroll;
  height: calc(100% - 100px);
  table-layout: fixed;
}
table::-webkit-scrollbar {
  //width:  5px;
  //height: 5px;
  //visibility: hidden;
}
tr {
  width: 100%;
}
td,
th {
  padding: 8px;
  margin: auto;
  font-size: smaller;
  border-style: solid;
  border-width: 1px;
  border-color: #aa0066;
}
td {
  text-align: left;
  overflow: scroll;
  padding: 8px;
}
td > div::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  visibility: hidden;
}
th {
  color: #fff;
  background: #aa0066;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10000;
}
table tr:nth-child(odd) {
  background: #ffeeff;
}
table tr:nth-child(even) {
  background: #fafafa;
}
.container {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  max-width: 500px;
  background: #fefefe;
  padding: 16px;
  z-index: 201;
}
.trans-btn {
  width: 100%;
  height: 35px;
  background: transparent;
  border: none;
  cursor: pointer;
}
.omit-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components2/Manage/modal/DetailSheetSetting.vue